import React, { useEffect, useState } from 'react'
import { api, auth, PROCESS_RESULTS, PROCESS_RESULT_PENDING } from '../lib/api'
import DateInput from '../components/DateInput'
import { formatBeijingDate, formatBeijingTime } from '../lib/time'

const fmt = (t) => formatBeijingTime(t)
const fmtDate = (t) => formatBeijingDate(t)

function resultTagClass(r) {
  if (!r) return 'tag tag-pending'
  return r === '退货退款' ? 'tag tag-refund' : 'tag tag-paid'
}

export default function Orders() {
  const [filters, setFilters] = useState({
    follow_from: '', follow_to: '', process_from: '', process_to: '',
    assigned_to: '', process_result: '', keyword: '',
  })
  const [data, setData] = useState({ orders: [], total: 0 })
  const [page, setPage] = useState(1)
  const [staffOptions, setStaffOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState('')
  const [followUpOrder, setFollowUpOrder] = useState(null)
  const [editOrder, setEditOrder] = useState(null)
  const [creating, setCreating] = useState(false)
  const [revealed, setRevealed] = useState(null)

  async function load(p = page) {
    setLoading(true); setErr('')
    try {
      const res = await api.listOrders({ ...filters, page: p, page_size: 20 })
      setData(res); setPage(p)
    } catch (e) { setErr(e.message) } finally { setLoading(false) }
  }

  useEffect(() => { load(1) }, [])
  useEffect(() => {
    if (auth.canManageStaff) api.listStaff().then(r => setStaffOptions(r.staff)).catch(() => {})
  }, [])

  async function reveal(order) {
    try {
      const { phone } = await api.revealPhone(order.id)
      setRevealed({ name: order.customer_name, phone })
    } catch (e) { setErr(e.message) }
  }

  async function remove(order) {
    if (!confirm(`确定删除订单「${order.customer_name}」吗？跟进记录会一并删除，不可恢复。`)) return
    try {
      await api.deleteOrder(order.id)
      load(page)
    } catch (e) { setErr(e.message) }
  }

  const totalPages = Math.max(Math.ceil(data.total / 20), 1)

  return (
    <div>
      <div className="card filters">
        <div className="field">
          <label className="small muted">跟进日期从</label>
          <DateInput value={filters.follow_from} onChange={e => setFilters({ ...filters, follow_from: e.target.value })} />
        </div>
        <div className="field">
          <label className="small muted">到</label>
          <DateInput value={filters.follow_to} onChange={e => setFilters({ ...filters, follow_to: e.target.value })} />
        </div>
        <div className="field">
          <label className="small muted">处理时间从</label>
          <DateInput value={filters.process_from} onChange={e => setFilters({ ...filters, process_from: e.target.value })} />
        </div>
        <div className="field">
          <label className="small muted">到</label>
          <DateInput value={filters.process_to} onChange={e => setFilters({ ...filters, process_to: e.target.value })} />
        </div>
        {auth.canManageStaff && (
          <div className="field">
            <label className="small muted">售后人员</label>
            <select className="select" value={filters.assigned_to} onChange={e => setFilters({ ...filters, assigned_to: e.target.value })}>
              <option value="">全部</option>
              {staffOptions.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </div>
        )}
        <div className="field">
          <label className="small muted">处理结果</label>
          <select className="select" value={filters.process_result} onChange={e => setFilters({ ...filters, process_result: e.target.value })}>
            <option value="">全部</option>
            <option value={PROCESS_RESULT_PENDING}>跟进中</option>
            {PROCESS_RESULTS.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
        <div className="field" style={{ minWidth: 220 }}>
          <label className="small muted">关键词</label>
          <input className="input" placeholder="姓名 / 电话 / 车牌" value={filters.keyword}
            onChange={e => setFilters({ ...filters, keyword: e.target.value })}
            onKeyDown={e => e.key === 'Enter' && load(1)} />
        </div>
        <button className="btn btn-primary" onClick={() => load(1)}>查询</button>
        <button className="btn" onClick={() => { setFilters({
          follow_from: '', follow_to: '', process_from: '', process_to: '',
          assigned_to: '', process_result: '', keyword: '',
        }) }}>重置</button>
        <div style={{ marginLeft: 'auto' }}>
          <button className="btn btn-primary" onClick={() => setCreating(true)}>新增订单</button>
        </div>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>跟进时间</th><th>客户姓名</th><th>车牌</th><th>电话号码</th>
                <th>处理结果</th><th>处理时间</th><th>售后人员</th><th>备注</th><th>操作</th>
              </tr>
            </thead>
            <tbody>
              {data.orders.map(o => (
                <tr key={o.id}>
                  <td>{fmtDate(o.next_follow_time)}</td>
                  <td>{o.customer_name}</td>
                  <td>{o.plate}</td>
                  <td><span className="phone-cell mono" onClick={() => reveal(o)}>{o.phone}</span></td>
                  <td><span className={resultTagClass(o.process_result)}>{o.process_result || '跟进中'}</span></td>
                  <td className="small muted">{fmt(o.process_time)}</td>
                  <td>{o.assigned_name}</td>
                  <td className="small muted">{o.remark}</td>
                  <td>
                    <button className="btn-link btn-sm" onClick={() => setFollowUpOrder(o)}>记录</button>
                    <button className="btn-link btn-sm" onClick={() => setEditOrder(o)}>编辑</button>
                    {auth.isAdmin && <button className="btn-link btn-sm" style={{ color: 'var(--danger)' }} onClick={() => remove(o)}>删除</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!loading && !data.orders.length && <div className="empty">暂无订单</div>}
        {loading && <div className="empty">加载中…</div>}
        <div className="pager spread">
          <span className="small muted">共 {data.total} 条</span>
          <div className="row">
            <button className="btn btn-sm" disabled={page <= 1} onClick={() => load(page - 1)}>上一页</button>
            <span className="small">{page} / {totalPages}</span>
            <button className="btn btn-sm" disabled={page >= totalPages} onClick={() => load(page + 1)}>下一页</button>
          </div>
        </div>
      </div>
      <div className="err">{err}</div>

      {revealed && (
        <div className="modal-bg" onClick={() => setRevealed(null)}>
          <div className="modal" style={{ maxWidth: 320 }} onClick={e => e.stopPropagation()}>
            <h2>{revealed.name}</h2>
            <div className="mono" style={{ fontSize: 20, marginBottom: 16 }}>{revealed.phone}</div>
            <div className="small muted">本次查看已记录</div>
            <button className="btn" style={{ marginTop: 16 }} onClick={() => setRevealed(null)}>关闭</button>
          </div>
        </div>
      )}

      {followUpOrder && <FollowUpModal order={followUpOrder} onClose={() => setFollowUpOrder(null)} onSaved={() => load(page)} />}
      {editOrder && <EditModal order={editOrder} staffOptions={staffOptions} onClose={() => setEditOrder(null)} onSaved={() => load(page)} />}
      {creating && <CreateModal staffOptions={staffOptions} onClose={() => setCreating(false)} onSaved={() => load(1)} />}
    </div>
  )
}

function FollowUpModal({ order, onClose, onSaved }) {
  const [list, setList] = useState([])
  const [content, setContent] = useState('')
  const [nextTime, setNextTime] = useState('')
  const [err, setErr] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => { api.listFollowUps(order.id).then(r => setList(r.follow_ups)).catch(e => setErr(e.message)) }, [order.id])

  async function submit() {
    if (!content.trim()) return
    setSaving(true); setErr('')
    try {
      await api.addFollowUp(order.id, { content, ...(nextTime ? { next_follow_time: nextTime } : {}) })
      const r = await api.listFollowUps(order.id)
      setList(r.follow_ups); setContent(''); setNextTime('')
      onSaved()
    } catch (e) { setErr(e.message) } finally { setSaving(false) }
  }

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal modal-lg" onClick={e => e.stopPropagation()}>
        <h2>{order.customer_name} · 跟进记录</h2>
        <div className="field">
          <label>本次跟进内容</label>
          <textarea className="input" rows={3} value={content} onChange={e => setContent(e.target.value)} />
        </div>
        <div className="field">
          <label>跟进时间</label>
          <DateInput value={nextTime} onChange={e => setNextTime(e.target.value)} />
        </div>
        <div className="row">
          <button className="btn btn-primary" onClick={submit} disabled={saving || !content.trim()}>添加记录</button>
          <button className="btn" onClick={onClose}>关闭</button>
        </div>
        <div className="err">{err}</div>
        <div style={{ marginTop: 12 }}>
          {list.map(f => (
            <div key={f.id} className="timeline-item">
              <div className="row small muted">
                <span>{fmt(f.created_at)}</span>
                <span>{f.operator_name}</span>
                <span className="tag">{{ admin: '管理员', leader: '组长', agent: '专员' }[f.operator_role] || f.operator_role}</span>
              </div>
              <div style={{ marginTop: 4 }}>{f.content}</div>
            </div>
          ))}
          {!list.length && <div className="empty">暂无跟进记录</div>}
        </div>
      </div>
    </div>
  )
}

function EditModal({ order, staffOptions, onClose, onSaved }) {
  const [form, setForm] = useState({
    plate: order.plate || '',
    remark: order.remark || '',
    process_result: order.process_result || '',
    activated: order.activated,
    assigned_to: order.assigned_to || '',
    next_follow_time: order.next_follow_time ? order.next_follow_time.slice(0, 10) : '',
  })
  const [err, setErr] = useState('')
  const [saving, setSaving] = useState(false)

  async function submit() {
    setSaving(true); setErr('')
    try {
      await api.updateOrder(order.id, {
        plate: form.plate,
        remark: form.remark,
        process_result: form.process_result || null,
        activated: form.activated,
        next_follow_time: form.next_follow_time || null,
        ...(auth.canManageStaff ? { assigned_to: form.assigned_to || null } : {}),
      })
      onSaved(); onClose()
    } catch (e) { setErr(e.message) } finally { setSaving(false) }
  }

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2>编辑订单 · {order.customer_name}</h2>
        <div className="field">
          <label>车牌</label>
          <input className="input" value={form.plate} onChange={e => setForm({ ...form, plate: e.target.value })} />
        </div>
        <div className="field">
          <label>处理结果</label>
          <select className="select" value={form.process_result} onChange={e => setForm({ ...form, process_result: e.target.value })}>
            <option value="">跟进中（未出结果）</option>
            {PROCESS_RESULTS.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
        <div className="field">
          <label>跟进时间</label>
          <DateInput value={form.next_follow_time} onChange={e => setForm({ ...form, next_follow_time: e.target.value })} />
        </div>
        {auth.canManageStaff && (
          <div className="field">
            <label>售后人员</label>
            <select className="select" value={form.assigned_to} onChange={e => setForm({ ...form, assigned_to: e.target.value })}>
              <option value="">未分配</option>
              {staffOptions.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </div>
        )}
        <div className="field">
          <label className="row" style={{ cursor: 'pointer' }}>
            <input type="checkbox" checked={form.activated} onChange={e => setForm({ ...form, activated: e.target.checked })} />
            <span>已激活</span>
          </label>
        </div>
        <div className="field">
          <label>备注</label>
          <textarea className="input" rows={2} value={form.remark} onChange={e => setForm({ ...form, remark: e.target.value })} />
        </div>
        <div className="row">
          <button className="btn btn-primary" onClick={submit} disabled={saving}>保存</button>
          <button className="btn" onClick={onClose}>取消</button>
        </div>
        <div className="err">{err}</div>
      </div>
    </div>
  )
}

function CreateModal({ staffOptions, onClose, onSaved }) {
  const [form, setForm] = useState({ customer_name: '', phone: '', plate: '', source_order_sn: '', assigned_to: '', remark: '' })
  const [err, setErr] = useState('')
  const [saving, setSaving] = useState(false)
  const [lookupKw, setLookupKw] = useState('')
  const [looking, setLooking] = useState(false)
  const [lookupMsg, setLookupMsg] = useState('')

  async function lookup() {
    if (!lookupKw.trim()) return
    setLooking(true); setLookupMsg('')
    try {
      const { results } = await api.cwtLookup(lookupKw.trim())
      if (!results.length) { setLookupMsg('车网通未查到，请手动填写'); return }
      const r = results[0]
      setForm(f => ({
        ...f,
        customer_name: r.customer_name || f.customer_name,
        phone: r.phone || f.phone,
        plate: r.plate || f.plate,
        source_order_sn: r.source_order_sn || f.source_order_sn,
      }))
      setLookupMsg(results.length > 1 ? `查到 ${results.length} 条，已带入第一条` : '已带入')
    } catch (e) { setLookupMsg('带入失败：' + e.message) } finally { setLooking(false) }
  }

  async function submit() {
    setSaving(true); setErr('')
    try {
      await api.createOrder({
        ...form,
        assigned_to: form.assigned_to || undefined,
      })
      onSaved(); onClose()
    } catch (e) { setErr(e.message) } finally { setSaving(false) }
  }

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2>新增订单</h2>
        <div className="field">
          <label>车网通自动带入（输车牌或手机号）</label>
          <div className="row">
            <input className="input" placeholder="粤A12345 或 138…" value={lookupKw}
              onChange={e => setLookupKw(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && lookup()} />
            <button className="btn" style={{ whiteSpace: 'nowrap' }} onClick={lookup} disabled={looking || !lookupKw.trim()}>
              {looking ? '查询中…' : '自动带入'}
            </button>
          </div>
          {lookupMsg && <div className="small muted" style={{ marginTop: 4 }}>{lookupMsg}</div>}
        </div>
        <div className="field">
          <label>客户姓名 *</label>
          <input className="input" value={form.customer_name} onChange={e => setForm({ ...form, customer_name: e.target.value })} autoFocus />
        </div>
        <div className="field">
          <label>电话号码 *</label>
          <input className="input" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
        </div>
        <div className="field">
          <label>车牌</label>
          <input className="input" value={form.plate} onChange={e => setForm({ ...form, plate: e.target.value })} />
        </div>
        {auth.canManageStaff && (
          <div className="field">
            <label>售后人员</label>
            <select className="select" value={form.assigned_to} onChange={e => setForm({ ...form, assigned_to: e.target.value })}>
              <option value="">分配给我自己</option>
              {staffOptions.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </div>
        )}
        <div className="field">
          <label>备注</label>
          <textarea className="input" rows={2} value={form.remark} onChange={e => setForm({ ...form, remark: e.target.value })} />
        </div>
        <div className="row">
          <button className="btn btn-primary" onClick={submit} disabled={saving || !form.customer_name || !form.phone}>创建</button>
          <button className="btn" onClick={onClose}>取消</button>
        </div>
        <div className="err">{err}</div>
      </div>
    </div>
  )
}
